import { SearchParamType } from "@/types/SearchParamType";
import { getUpdatedSearchParams } from "@/components/utils";
export var getPageParams = function (searchParams, pageCursor, fallbackCountry) {
    if (fallbackCountry === void 0) { fallbackCountry = ""; }
    var what = searchParams.get(SearchParamType.WHAT) || "";
    var where = searchParams.get(SearchParamType.WHERE) || "";
    var country = searchParams.get(SearchParamType.COUNTRY) || fallbackCountry;
    var isRemoteOnly = searchParams.get(SearchParamType.IS_REMOTE_ONLY) === "true";
    return getUpdatedSearchParams(searchParams, what, where, isRemoteOnly, pageCursor, country);
};
export var getPageHref = function (searchParams, pageCursor, fallbackCountry) {
    if (fallbackCountry === void 0) { fallbackCountry = ""; }
    var currentUrl = new URL(window.location.href);
    var what = searchParams.get(SearchParamType.WHAT) || "";
    var where = searchParams.get(SearchParamType.WHERE) || "";
    var country = searchParams.get(SearchParamType.COUNTRY) || fallbackCountry;
    var isRemoteOnly = searchParams.get(SearchParamType.IS_REMOTE_ONLY) === "true";
    var updatedParams = getUpdatedSearchParams(currentUrl.searchParams, what, where, isRemoteOnly, pageCursor, country);
    var queryParams = updatedParams.toString() === "" ? "" : "?".concat(updatedParams.toString());
    return "".concat(currentUrl.pathname).concat(queryParams);
};
